<template>
  <div v-if="languageStatisticsPresenter.isLoading.value" class="flex justify-center items-center h-full">
    <LoadingPanel />
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="languageStatisticsPresenter.chartOptions.value"
    :series="languageStatisticsPresenter.chartSeries.value"
    type="bar"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, languageStatisticsChartColor } from '@/domain/value_objects/color/ColorList'
import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useLanguageStatisticsPresenter } from '@/presentation/composables/dashboard/useLanguageStatisticsPresenter'

export default defineComponent({
  components: { VueApexCharts, LoadingPanel },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const languageStatisticsPresenter = useLanguageStatisticsPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      languageStatisticsPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        languageStatisticsChartColor,
        dashboardTargetColor,
        displayLanguage.value,
        isLightMode()
      )
    }

    onMounted(() => {
      // initChart()
    })

    return {
      initChart,
      dashboardModalStatePresenter,
      languageStatisticsPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
